import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  RowVisibility,
} from "../../../shared/filters/types/filter";
import type { ApplyFilter } from "../../../shared/filters/types/apply";
import type { LaunchMedia } from "../../types/launch";
import {
  matchesSelection,
  sortedUnique,
  type LaunchMediaRow,
} from "../../utils/launchMediaFilters";
import { getMediaTypeLabel, normalizeMediaType } from "../../utils/mediaType";

const MEDIA_TYPE_ID = "mediaType";

export function useMediaTypeMultiSelectFilter(
  medias: LaunchMedia[]
): ApplyFilter<MultiSelectFilter, LaunchMediaRow> {
  const { t } = useTranslation();
  const values = sortedUnique(
    medias.map((m) => normalizeMediaType(m.media_type))
  );

  return {
    filter: {
      inputType: InputType.MultiSelect,
      filterType: FilterType.Filter,
      id: MEDIA_TYPE_ID,
      title: t("allMediaTypesString"),
      options: values.map((value) => ({
        value,
        title: getMediaTypeLabel(value),
      })),
      enabled: true,
      rowVisibility: RowVisibility.PillOnly,
      defaultValue: { filterId: MEDIA_TYPE_ID, value: [] },
    },
    filterCompare: ({ media }: LaunchMediaRow, { value }: FilterValue) =>
      matchesSelection(value, values, normalizeMediaType(media.media_type)),
  };
}
